<template>
	<div id="news">
		<div class="header">
			<div class="headerContainer">
				News
			</div>
		</div>
		<div class="timeline">
			<div class="warning">
				<i class="fa fa-arrow-left"></i>
				Swipe for more
				<i class="fa fa-arrow-right"></i>
			</div>

			<carousel class="newCarousel"
						:navigationEnabled="true" 
						:perPageCustom="[[375, 1], [425, 1], [768, 2], [1024, 3], [1440, 3]]">
				<slide v-for="(event, index) in newsFiltered" :key="index" class="slider"> 
					<div class="event-date">{{event.title.rendered}}</div>
					<div class="event-description" v-html="event.content.rendered"></div>
				</slide>
			</carousel>
		</div>
	</div>
</template>

<script>
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import dayjs from 'dayjs';

export default{
	name:"News",
	props: {
		'news' : {
			type: Array,
			default: function(){
				return this.defaultNews;
			}
		}
	},
	data(){
		return {
			currDate: dayjs().format('DD/MM/YYYY'),
			defaultNews : [{
				date: this.currDate,
				leftBuffer: 0,
				older: false,
				title: { rendered: "title" }
			}],
			newsFiltered: this.defaultNews,
			loaded: false
		}
	},
	methods: {
		parseDate : function(){
			let dateArrays = [];
			for(var i=0 ; i< this.newsFiltered.length ; i++){
				let singleDate = this.newsFiltered[i].date,
					dayComp = singleDate.split('-'),
					timeComp = ["0", "0"];
				let	newDate = new Date(dayComp[1], dayComp[0], 0, timeComp[0], timeComp[1]);
				dateArrays.push(newDate);				
			}
			this.dateValues = dateArrays;
		},
		getNewsContent: function(){
        	this.newsFiltered = filter(this.news, function(o){
        		return includes(o['tags'], 11);
        	});

        	map(this.newsFiltered, function(post){
        		let base = dayjs(post.title.rendered);
        		post['textDate'] 	 = base.format('D MMMM');
        		post['fullTextDate'] = base.format('MMMM D, YYYY');
        		post['date'] 		 = base.format('M-YYYY');
        		post['older'] = true;
        	});

        	this.newsFiltered = orderBy(this.newsFiltered, function(o) { 
        		return new Date(o.fullTextDate); 
        	}, ['desc']);
        	this.newsFiltered[0]['older'] = false;
        	// this.newsFiltered.reverse();

        	this.parseDate();
        	this.loaded = true;
		}
	},
	watch: {
		news: function(){
			this.getNewsContent();
		}
	}
}
</script>

<style scoped>
	.event-description >>> p:first-child {
		margin: 20px;
		display: block;
	}
	.event-description >>> p:last-child {
		margin: auto;
		overflow: hidden;
	}
	.event-description >>> em {
		font-style: italic;
	}
	.event-description >>> img {
		margin: auto;
		max-width: 200px;
		width: 100%;
		height: auto;
		max-height: 150px;
		display: flex;
	}

</style>

<style scoped lang="scss">
	@import '~@/assets/scss/_variables.scss';

	#news{
		height: 90vh;
		width: 100vw;
		padding: 20px;
		background: $lightPurple;
		background: linear-gradient(180deg, $lightPurple 0%, $darkPurple 100%);
		display: grid;
		grid-template-rows: 20% 80%;

	}

	.header{
		.headerContainer{
			float: right;
			display: block;
			text-align: center;
			width: 50%;
			font-family: 'Raleway', 'sans-serif';
			font-weight: bold;
			color: $nearWhite;
			font-size: 7rem;
		}
	}

	.timeline{
		width: 100%;
		height: 100%;
		margin: auto;
		overflow: hidden;
		
		.warning{
			display: none;
			width: 100%;
			text-align: center;
			color: white;
			font-family: 'Montserrat', sans-serif;
			margin: 10px auto;			
		}

		.newCarousel{
			width: 90%;
			margin: auto;
			max-height: 750px;
		}

		.slider{
			font-family: 'Raleway', 'sans-serif';
			padding: 10px 0;
			background: white;
			border-radius: 10px;
			border-left: 7px solid #54545477;
			border-bottom: 7px solid #54545477;
			max-height: 400px;

			.event-date{
				// color: $nearWhite;
				color: black;
				font-weight: 700;
				font-size: 2em;
				text-align: center;
			}

			.event-description{
				display: grid;
				grid-template-rows: repeat(2, 1fr);
				grid-gap: 5px;
				color: black;
				font-family: 'Montserrat', sans-serif;
				height: 90%;
	
				.wp-block-image{
					display: flex;
				}
			}
		}
	}

	@media screen and (max-width: $regularLaptopWidth){
		.timeline{
			.newCarousel{
				width: 90%;
				margin: auto;
			}
			
		}		
	}
	@media screen and (max-width: $tabletWidth){
		.timeline{
			.warning{
				display: block;
			}
			.newCarousel{
			}
		}
	}
	@media screen and (min-width: $largeMobile){
		.timeline{
			.timeline-events{
				.timeline-event{
					.event-description{
    					grid-template-columns: 50% 50%;
					}
				}
			}
		}
	}
	@media screen and (max-width: $largeMobile){
		#news{
			.header{
				.headerContainer{
					float: none;
				}
			}
		}

		.timeline{
			width: 100%;
			margin-top: 10px;

			.newCarousel{
				width: 100%;
				margin: 0;
			}
			.warning{
				display: block;
				width: 100%;
				text-align: center;
				color: white;
				font-family: 'Montserrat', sans-serif;
				margin: 10px auto;
			}


			.timeline-events{
				border: 3px solid $nearWhite;

				.timeline-event{
					.event-description{
    					grid-template-columns: initial;
					}
				}
			}
		}
	}

	@keyframes enter-right{
		0%{
			opacity: 0;
			transform: translateX(-100%);
		}

		100%{
			opacity: 1;
			transform: translateX(0%);
		}
	}

	@keyframes enter-left{
		0%{
			opacity: 0;
			transform: translateX(-100%);
		}

		100%{
			opacity: 1;
			transformX:(0%);
		}
	}

</style>
